import React, { Component } from "react";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import DOMPurify from "dompurify";
import store from "../../store";
import { SendContact } from "../../actions";
import ScrollToTop from "./scroll_to_top";
import HeadSEO from "../layouts/tradnity/headSEO";
import {
  FaInstagram,
  FaFacebookF,
  FaPinterestP,
  FaTiktok,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./ContactPage.css";

import heroModelImg from "../../assets/images/about-top-banner.png";
import storeImg from "../../assets/images/karachi-store.jpg";

class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: "",
      email: "",
      subject: "",
      message: "",
    };
    this.validator = new SimpleReactValidator();
  }

  setField = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const clean = (v) =>
        DOMPurify.sanitize(v, { USE_PROFILES: { html: false } });
      const data = {
        first_name: clean(this.state.full_name),
        last_name: "",
        description: clean(this.state.message),
        phone_number: "",
        email: clean(this.state.email),
      };
      const loader = document.querySelector(".loader-wrapper");
      if (loader) loader.style.display = "block";
      store.dispatch(SendContact(data));
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { contactDetails } = this.props;
    const cd = contactDetails?.data || {};
    const phone = cd.phone_number
      ? `+${cd.phone_number}`
      : "+92 21 1234 5678";
    const emailAddr = cd.email || "info@shanzbyshanzay.com";
    const address =
      cd.shop_address || "B-12, Clifton Centre, Block 5\nClifton, Karachi, Pakistan";
    const fbUrl = cd.facebook_page || "/#";
    const igUrl = cd.instagram_page || "/#";
    const ttUrl = cd.twitter_page || "/#";
    const pinUrl = "/#";

    return (
      <div className="cp-root">
        <ScrollToTop />
        <HeadSEO title="Contact Us | SHANZ BY SHANZAY" />

        {/* ══════════════════════════════════════════
            1. HERO — Split Layout (Copy Left, Model Right)
            ══════════════════════════════════════════ */}
        <section className="cp-hero">
          <div className="cp-hero-copy">
            <div className="cp-eyebrow">
              <span className="cp-eyebrow-text">GET IN TOUCH</span>
              <span className="cp-eyebrow-line" />
            </div>
            <h1 className="cp-hero-h1">
              WE'D LOVE TO<br />
              <em className="cp-hero-em">HEAR FROM YOU</em>
            </h1>
            <p className="cp-hero-p">
              Whether you have a question, need assistance<br />
              or just want to say hello — we're here for you.
            </p>
          </div>
          <div className="cp-hero-img-wrap" aria-hidden="true">
            <img
              src={heroModelImg || `${process.env.PUBLIC_URL}/about-top-banner.png`}
              alt="Get in Touch"
              className="cp-hero-img"
              loading="eager"
            />
          </div>
        </section>

        {/* ══════════════════════════════════════════
            2. MIDDLE — CONTACT DETAILS + FORM
            ══════════════════════════════════════════ */}
        <section className="cp-middle-section">
          <div className="cp-middle">
            {/* Left — Contact Details */}
            <div className="cp-details-col">
              <div className="cp-eyebrow">
                <span className="cp-eyebrow-text">CONTACT DETAILS</span>
                <span className="cp-eyebrow-line" />
              </div>

              {/* Phone */}
              <div className="cp-detail-item">
                <div className="cp-detail-icon-wrap">
                  <FaPhone className="cp-detail-icon" />
                </div>
                <div className="cp-detail-body">
                  <span className="cp-detail-label">PHONE</span>
                  <a href={`tel:${phone}`} className="cp-detail-value">
                    {phone}
                  </a>
                  <span className="cp-detail-sub">
                    Mon - Sat, 10:00 AM – 7:00 PM
                  </span>
                </div>
              </div>

              {/* Email */}
              <div className="cp-detail-item">
                <div className="cp-detail-icon-wrap">
                  <FaEnvelope className="cp-detail-icon" />
                </div>
                <div className="cp-detail-body">
                  <span className="cp-detail-label">EMAIL</span>
                  <a href={`mailto:${emailAddr}`} className="cp-detail-value">
                    {emailAddr}
                  </a>
                  <span className="cp-detail-sub">
                    We'll respond within 24 hours.
                  </span>
                </div>
              </div>

              {/* Store Location */}
              <div className="cp-detail-item">
                <div className="cp-detail-icon-wrap">
                  <FaMapMarkerAlt className="cp-detail-icon" />
                </div>
                <div className="cp-detail-body">
                  <span className="cp-detail-label">STORE LOCATION</span>
                  <span className="cp-detail-value">
                    B-12, Clifton Centre, Block 5
                  </span>
                  <span className="cp-detail-value">
                    Clifton, Karachi, Pakistan
                  </span>
                  <a
                    href={`https://maps.google.com/?q=${encodeURIComponent(
                      address.replace("\n", " ")
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cp-directions-link"
                  >
                    Get Directions &nbsp;&#8594;
                  </a>
                </div>
              </div>

              {/* Follow Us */}
              <div className="cp-detail-item">
                <div className="cp-detail-icon-wrap">
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="#F5B96D"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <circle cx="12" cy="12" r="3.5" />
                    <circle cx="12" cy="12" r="1" fill="#F5B96D" />
                  </svg>
                </div>
                <div className="cp-detail-body">
                  <span className="cp-detail-label">FOLLOW US</span>
                  <div className="cp-social-row">
                    <a
                      href={igUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cp-social-icon"
                      aria-label="Instagram"
                    >
                      <FaInstagram />
                    </a>
                    <a
                      href={fbUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cp-social-icon"
                      aria-label="Facebook"
                    >
                      <FaFacebookF />
                    </a>
                    <a
                      href={pinUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cp-social-icon"
                      aria-label="Pinterest"
                    >
                      <FaPinterestP />
                    </a>
                    <a
                      href={ttUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cp-social-icon"
                      aria-label="TikTok"
                    >
                      <FaTiktok />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right — Send Us a Message Form */}
            <div className="cp-form-col">
              <div className="cp-eyebrow">
                <span className="cp-eyebrow-text">SEND US A MESSAGE</span>
                <span className="cp-eyebrow-line" />
              </div>

              <form className="cp-form" onSubmit={this.handleSubmit} noValidate>
                {/* Full Name */}
                <div className="cp-field-group">
                  <label className="cp-label" htmlFor="cp-full-name">
                    Full Name <span className="cp-required">*</span>
                  </label>
                  <input
                    id="cp-full-name"
                    type="text"
                    name="full_name"
                    placeholder="Your name"
                    value={this.state.full_name}
                    onChange={this.setField}
                    className="cp-input"
                    autoComplete="name"
                  />
                  {this.validator.message(
                    "full_name",
                    this.state.full_name,
                    "required"
                  )}
                </div>

                {/* Email */}
                <div className="cp-field-group">
                  <label className="cp-label" htmlFor="cp-email">
                    Email Address <span className="cp-required">*</span>
                  </label>
                  <input
                    id="cp-email"
                    type="email"
                    name="email"
                    placeholder="Your email"
                    value={this.state.email}
                    onChange={this.setField}
                    className="cp-input"
                    autoComplete="email"
                  />
                  {this.validator.message(
                    "email",
                    this.state.email,
                    "required|email"
                  )}
                </div>

                {/* Subject */}
                <div className="cp-field-group">
                  <label className="cp-label" htmlFor="cp-subject">
                    Subject <span className="cp-required">*</span>
                  </label>
                  <select
                    id="cp-subject"
                    name="subject"
                    value={this.state.subject}
                    onChange={this.setField}
                    className="cp-input cp-select"
                  >
                    <option value="">Select an option</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Order Status">Order Status</option>
                    <option value="Custom Jewellery">Custom Jewellery</option>
                    <option value="Returns & Exchanges">
                      Returns &amp; Exchanges
                    </option>
                    <option value="Feedback">Feedback</option>
                    <option value="Other">Other</option>
                  </select>
                  {this.validator.message(
                    "subject",
                    this.state.subject,
                    "required"
                  )}
                </div>

                {/* Message */}
                <div className="cp-field-group">
                  <label className="cp-label" htmlFor="cp-message">
                    Your Message <span className="cp-required">*</span>
                  </label>
                  <textarea
                    id="cp-message"
                    name="message"
                    rows={5}
                    placeholder="How can we help you?"
                    value={this.state.message}
                    onChange={this.setField}
                    className="cp-input cp-textarea"
                  />
                  {this.validator.message(
                    "message",
                    this.state.message,
                    "required"
                  )}
                </div>

                <button type="submit" className="cp-submit-btn">
                  Send Message &nbsp;&#8594;
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* ══════════════════════════════════════════
            3. VISIT OUR STORE — Interior Photo + Copy + Map Card
            ══════════════════════════════════════════ */}
        <section className="cp-store-section">
          <div className="cp-store-container">
            {/* Left: Showroom Interior Image */}
            <div className="cp-store-img-wrap">
              <img
                src={storeImg || `${process.env.PUBLIC_URL}/karachi-store.jpg`}
                alt="SHANZ BY SHANZAY Karachi Store"
                className="cp-store-img"
                loading="lazy"
              />
            </div>

            {/* Center: Store Copy & Directions */}
            <div className="cp-store-copy">
              <div className="cp-eyebrow">
                <span className="cp-eyebrow-text">VISIT OUR STORE</span>
                <span className="cp-eyebrow-line" />
              </div>
              <h2 className="cp-store-h2">
                KARACHI <em className="cp-store-em">STORE</em>
              </h2>
              <p className="cp-store-desc">
                Experience our latest collections in person at our Karachi
                store. Our team will be happy to assist you and help you find
                the perfect piece.
              </p>
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(
                  address.replace("\n", " ")
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="cp-store-btn"
              >
                Get Directions &nbsp;&#8594;
              </a>
              <div className="cp-store-addr-box">
                <FaMapMarkerAlt className="cp-store-addr-icon" />
                <span className="cp-store-addr-text">
                  B-12, Clifton Centre, Block 5<br />
                  Clifton, Karachi, Pakistan
                </span>
              </div>
            </div>

            {/* Right: Dark Clifton Centre Map Card */}
            <div className="cp-map-wrap">
              <iframe
                title="Store location map"
                src="https://maps.google.com/maps?q=Clifton+Centre+Block+5+Karachi&t=&z=15&ie=UTF8&iwloc=&output=embed"
                className="cp-map-iframe"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="cp-map-pin-overlay">
                <div className="cp-map-pin-badge">
                  <FaMapMarkerAlt className="cp-map-pin-icon" />
                  <span>Clifton Centre</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contactDetails: state.contactDetails?.contactDetails,
  sociallinks: state.contactDetails?.socialLinks,
});

export default connect(mapStateToProps)(ContactPage);
